// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"622c8696","413":"006e8ea1","963":"ef997317"}[chunkId] + ".chunk.js";
};